import { apiFetch } from "./client";

export function getCities() {
  return apiFetch("/api/locations/cities");
}

export function getDistricts(cityId) {
  return apiFetch(`/api/locations/cities/${encodeURIComponent(cityId)}/districts`);
}
